import { IFontIconCard } from '@ecs/tng-common/interfaces';

type CardFields =
  | 'CreditreportScores'
  | 'FraudIdentityTheft'
  | 'Banking'
  | 'Bankruptcy'
  | 'CreditCards'
  | 'Loans'
  | 'Insurance'
  | 'Mortgage'
  | 'Investing'
  | 'PersonalFinance'
  | 'NewsResearch'
  | 'CertificateDepositCD'
  | 'CheckingAccount'
  | 'MoneyMarket'
  | 'SavingsAccount'
  | 'APR'
  | 'BalanceTransfers'
  | 'CashbackCreditCards'
  | 'CreditCardBasics'
  | 'RewardsCreditCards'
  | 'SecuredCreditCards'
  | 'StudentCreditCards'
  | 'TravelCreditCards'
  | 'CreditLimits'
  | 'ReportAdvice'
  | 'ScoreAdvice'
  | 'EstablishingCredit'
  | 'ImproveCredit'
  | 'CreditRepair'
  | 'LifeStages'
  | 'Dispute'
  | 'DeathRelative'
  | 'Divorce'
  | 'Employment'
  | 'Kids'
  | 'Marriage'
  | 'Students'
  | 'Cosigning'
  | 'Deniedcredit'
  | 'Inquiry'
  | 'Chargeoff'
  | 'Closedaccounts'
  | 'Collections'
  | 'Foreclosure'
  | 'Latepayment'
  | 'Repossession'
  | 'Negativeinformation'
  | 'Cybersecurity'
  | 'Databreach'
  | 'Fraudalert'
  | 'Prevention'
  | 'Securityfreeze'
  | 'Autoinsurance'
  | 'Healthinsurance'
  | 'Homeinsurance'
  | 'LifeInsurance'
  | 'PetInsurance'
  | 'Insurancereviews'
  | 'Autoloans'
  | 'Loanbasics'
  | 'Personalloans'
  | 'Studentloans'
  | 'HELOC'
  | 'Refinance'
  | 'Debt'
  | 'Research'
  | 'NewsTrends'
  | 'Budgeting'
  | 'Saving'
  | 'Retirement'
  | 'Taxes'
  | 'Rentals';

export interface ILinksSection {
  [key: string]: IFontIconCard[];
}

const cards: Record<CardFields, IFontIconCard> = {
  CreditreportScores: {
    icon: 'icon-score',
    heading: 'Credit report & scores',
    link: '/category/credit-advice/'
  },
  FraudIdentityTheft: {
    icon: 'icon-protection-shield',
    heading: 'Fraud & identity theft',
    link: '/category/fraud-and-identity-theft/'
  },
  Banking: {
    icon: 'icon-debt',
    heading: 'Banking',
    link: '/category/banking/'
  },
  CreditCards: {
    icon: 'icon-credit-card',
    heading: 'Credit cards',
    link: '/category/credit-cards/'
  },
  Loans: {
    icon: 'icon-money-bag',
    heading: 'Loans',
    link: '/category/loans/'
  },
  Insurance: {
    icon: 'icon-home-auto-insurance',
    heading: 'Insurance',
    link: '/category/insurance/'
  },
  Mortgage: {
    icon: 'icon-home',
    heading: 'Mortgage',
    link: '/category/personal-finance/mortgage/'
  },
  Investing: {
    icon: 'icon-money-tree',
    heading: 'Investing',
    link: '/category/personal-finance/investing/'
  },
  PersonalFinance: {
    icon: 'icon-wallet',
    heading: 'Personal finance',
    link: '/category/personal-finance/'
  },
  NewsResearch: {
    icon: 'icon-what-is-new',
    heading: 'News & research',
    link: '/category/news-trends/research/'
  },
  CertificateDepositCD: {
    icon: 'icon-certificate',
    heading: 'Certificate of deposit (CD)',
    link: '/category/banking/cd/'
  },
  CheckingAccount: {
    icon: 'icon-debt',
    heading: 'Checking account',
    link: '/category/banking/checking-account/'
  },
  MoneyMarket: {
    icon: 'icon-dollar',
    heading: 'Money market',
    link: '/category/banking/money-market/'
  },
  SavingsAccount: {
    icon: 'icon-piggy-bank',
    heading: 'Savings account',
    link: '/category/banking/saving-account/'
  },
  APR: {
    icon: 'icon-percent-burst',
    heading: 'APR',
    link: '/category/credit-cards/apr/'
  },
  BalanceTransfers: {
    icon: 'icon-balance-transfer',
    heading: 'Balance transfers',
    link: '/category/credit-cards/balance-transfers/'
  },
  CashbackCreditCards: {
    icon: 'icon-cashback',
    heading: 'Cash back credit cards',
    link: '/category/credit-cards/cash-back-credit-cards/'
  },
  CreditCardBasics: {
    icon: 'icon-layers',
    heading: 'Credit card basics',
    link: '/category/credit-cards/credit-card-basics/'
  },
  RewardsCreditCards: {
    icon: 'icon-new-item-offer',
    heading: 'Rewards credit cards',
    link: '/category/credit-cards/rewards-credit-cards/'
  },
  SecuredCreditCards: {
    icon: 'icon-secure-card',
    heading: 'Secured credit cards',
    link: '/category/credit-cards/secured-credit-cards/'
  },
  StudentCreditCards: {
    icon: 'icon-student-education',
    heading: 'Student credit cards',
    link: '/category/credit-cards/student-credit-cards/'
  },
  TravelCreditCards: {
    icon: 'icon-travel',
    heading: 'Travel credit cards',
    link: '/category/credit-cards/travel-credit-cards/'
  },
  CreditLimits: {
    icon: 'icon-test',
    heading: 'Credit limits',
    link: '/category/credit-advice/report-advice/credit-limit/'
  },
  ReportAdvice: {
    icon: 'icon-new-credit',
    heading: 'Report advice',
    link: '/category/credit-advice/report-advice/'
  },
  ScoreAdvice: {
    icon: 'icon-score',
    heading: 'Score advice',
    link: '/category/credit-advice/score-advice/'
  },
  EstablishingCredit: {
    icon: 'icon-credit-score',
    heading: 'Establishing credit',
    link: '/category/credit-advice/life-stages/establishing-credit/'
  },
  ImproveCredit: {
    icon: 'icon-chart-grow',
    heading: 'Improve credit',
    link: '/category/credit-advice/improve-credit/'
  },
  CreditRepair: {
    icon: 'icon-monitor',
    heading: 'Credit repair',
    link: '/category/credit-advice/report-advice/credit-repair/'
  },
  LifeStages: {
    icon: 'icon-stage-cycle',
    heading: 'Life stages',
    link: '/category/credit-advice/life-stages/'
  },
  Dispute: {
    icon: 'icon-file-check',
    heading: 'Dispute',
    link: '/category/credit-advice/report-advice/dispute/'
  },
  DeathRelative: {
    icon: 'icon-heart-broken',
    heading: 'Death of a relative',
    link: '/category/credit-advice/life-stages/death-of-a-relative/'
  },
  Divorce: {
    icon: 'icon-heart-bandaid',
    heading: 'Divorce',
    link: '/category/credit-advice/life-stages/divorce/'
  },
  Employment: {
    icon: 'icon-employment',
    heading: 'Employment',
    link: '/category/credit-advice/life-stages/employment/'
  },
  Kids: {
    icon: 'icon-child',
    heading: 'Kids',
    link: '/category/credit-advice/life-stages/kids/'
  },
  Marriage: {
    icon: 'icon-marriage-rings',
    heading: 'Marriage',
    link: '/category/credit-advice/life-stages/marriage/'
  },
  Students: {
    icon: 'icon-student-education',
    heading: 'Students',
    link: '/category/credit-advice/life-stages/students/'
  },
  Cosigning: {
    icon: 'icon-fill-form',
    heading: 'Cosigning',
    link: '/category/credit-advice/report-advice/cosigning/'
  },
  Deniedcredit: {
    icon: 'icon-credit-card-slash',
    heading: 'Denied credit',
    link: '/category/credit-advice/report-advice/denied-credit/'
  },
  Inquiry: {
    icon: 'icon-monitor',
    heading: 'Inquiry',
    link: '/category/credit-advice/report-advice/inquiry/'
  },
  Chargeoff: {
    icon: 'icon-file-closed',
    heading: 'Charge off',
    link: '/category/credit-advice/report-advice/charge-off/'
  },
  Closedaccounts: {
    icon: 'icon-file-closed',
    heading: 'Closed accounts',
    link: '/category/credit-advice/report-advice/closed-accounts/'
  },
  Collections: {
    icon: 'icon-money-envelope',
    heading: 'Collections',
    link: '/category/credit-advice/report-advice/collections/'
  },
  Foreclosure: {
    icon: 'icon-foreclosure',
    heading: 'Foreclosure',
    link: '/category/credit-advice/report-advice/foreclosure/'
  },
  Latepayment: {
    icon: 'icon-calendar-expired',
    heading: 'Late payment',
    link: '/category/credit-advice/report-advice/late-payment/'
  },
  Repossession: {
    icon: 'icon-link',
    heading: 'Repossession',
    link: '/category/credit-advice/report-advice/repossession/'
  },
  Negativeinformation: {
    icon: 'icon-negative-info',
    heading: 'Negative information',
    link: '/category/credit-advice/report-advice/negative-information/'
  },
  Bankruptcy: {
    icon: 'icon-money-bandaid',
    heading: 'Bankruptcy',
    link: '/category/credit-advice/report-advice/bankruptcy/'
  },
  Cybersecurity: {
    icon: 'icon-web-security',
    heading: 'Cybersecurity',
    link: '/category/fraud-and-identity-theft/cybersecurity/'
  },
  Databreach: {
    icon: 'icon-dark-web-info',
    heading: 'Data breach',
    link: '/category/fraud-and-identity-theft/data-breach/'
  },
  Fraudalert: {
    icon: 'icon-thin-file',
    heading: 'Fraud alert',
    link: '/category/fraud-and-identity-theft/fraud-alert/'
  },
  Prevention: {
    icon: 'icon-secure-message',
    heading: 'Prevention',
    link: '/category/fraud-and-identity-theft/prevention/'
  },
  Securityfreeze: {
    icon: 'icon-security-freeze',
    heading: 'Security freeze',
    link: '/category/fraud-and-identity-theft/security-freeze/'
  },
  Autoinsurance: {
    icon: 'icon-car',
    heading: 'Auto insurance',
    link: '/category/insurance/auto-insurance/'
  },
  Healthinsurance: {
    icon: 'icon-medical',
    heading: 'Health insurance',
    link: '/category/insurance/health-insurance/'
  },
  Homeinsurance: {
    icon: 'icon-home-renters-insurance',
    heading: 'Home insurance',
    link: '/category/insurance/home-insurance/'
  },
  LifeInsurance: {
    icon: 'icon-medical-protection',
    heading: 'Life Insurance',
    link: '/category/insurance/life-insurance/'
  },
  PetInsurance: {
    icon: 'icon-pet',
    heading: 'Pet insurance',
    link: '/category/insurance/pet-insurance/'
  },
  Insurancereviews: {
    icon: 'icon-magnify-glass-document',
    heading: 'Insurance reviews',
    link: '/category/insurance/insurance-reviews/'
  },
  Autoloans: {
    icon: 'icon-car',
    heading: 'Auto loans',
    link: '/category/loans/auto-loans/'
  },
  Loanbasics: {
    icon: 'icon-money-bag',
    heading: 'Loan basics',
    link: '/category/loans/loan-basics/'
  },
  Personalloans: {
    icon: 'icon-wallet',
    heading: 'Personal loans',
    link: '/category/loans/personal-loans/'
  },
  Studentloans: {
    icon: 'icon-student-education',
    heading: 'Student loans',
    link: '/category/loans/student-loans/'
  },
  HELOC: {
    icon: 'icon-certificate-money-check',
    heading: 'HELOC',
    link: '/category/personal-finance/heloc/'
  },
  Refinance: {
    icon: 'icon-mortgage-refi',
    heading: 'Refinance',
    link: '/category/personal-finance/refinance/'
  },
  Debt: {
    icon: 'icon-debt',
    heading: 'Debt',
    link: '/category/personal-finance/debt/'
  },
  Research: {
    icon: 'icon-news',
    heading: 'Research',
    link: '/category/news-trends/research/'
  },
  NewsTrends: {
    icon: 'icon-what-is-new',
    heading: 'News & trends',
    link: '/category/news-trends/'
  },
  Budgeting: {
    icon: 'icon-calculator',
    heading: 'Budgeting',
    link: '/category/personal-finance/budgeting/'
  },
  Saving: {
    icon: 'icon-piggy-bank',
    heading: 'Saving',
    link: '/category/personal-finance/saving/'
  },
  Retirement: {
    icon: 'icon-coin-jar',
    heading: 'Retirement',
    link: '/category/personal-finance/retirement/'
  },
  Taxes: {
    icon: 'icon-document-folder',
    heading: 'Taxes',
    link: '/category/personal-finance/taxes/'
  },
  Rentals: {
    icon: 'icon-key',
    heading: 'Rentals',
    link: '/category/personal-finance/mortgage/rentals/'
  }
};
export const exploreMoreLinks: ILinksSection = {
  cd: [cards.CheckingAccount, cards.MoneyMarket, cards.SavingsAccount, cards.PersonalFinance],
  'checking-account': [
    cards.CertificateDepositCD,
    cards.MoneyMarket,
    cards.SavingsAccount,
    cards.PersonalFinance
  ],
  'money-market': [
    cards.CertificateDepositCD,
    cards.CheckingAccount,
    cards.SavingsAccount,
    cards.PersonalFinance
  ],
  'saving-account': [
    cards.CertificateDepositCD,
    cards.CheckingAccount,
    cards.MoneyMarket,
    cards.PersonalFinance
  ],
  apr: [
    cards.BalanceTransfers,
    cards.CashbackCreditCards,
    cards.CreditCardBasics,
    cards.RewardsCreditCards,
    cards.SecuredCreditCards,
    cards.StudentCreditCards,
    cards.TravelCreditCards,
    cards.CreditLimits
  ],
  'balance-transfers': [
    cards.APR,
    cards.CashbackCreditCards,
    cards.CreditCardBasics,
    cards.RewardsCreditCards,
    cards.SecuredCreditCards,
    cards.StudentCreditCards,
    cards.TravelCreditCards,
    cards.CreditLimits
  ],
  'cash-back-credit-cards': [
    cards.APR,
    cards.BalanceTransfers,
    cards.CreditCardBasics,
    cards.RewardsCreditCards,
    cards.SecuredCreditCards,
    cards.StudentCreditCards,
    cards.TravelCreditCards,
    cards.CreditLimits
  ],
  'credit-card-basics': [
    cards.APR,
    cards.BalanceTransfers,
    cards.CashbackCreditCards,
    cards.RewardsCreditCards,
    cards.SecuredCreditCards,
    cards.StudentCreditCards,
    cards.TravelCreditCards,
    cards.CreditLimits
  ],
  'rewards-credit-cards': [
    cards.APR,
    cards.BalanceTransfers,
    cards.CashbackCreditCards,
    cards.CreditCardBasics,
    cards.SecuredCreditCards,
    cards.StudentCreditCards,
    cards.TravelCreditCards,
    cards.CreditLimits
  ],
  'secured-credit-cards': [
    cards.APR,
    cards.BalanceTransfers,
    cards.CashbackCreditCards,
    cards.CreditCardBasics,
    cards.RewardsCreditCards,
    cards.StudentCreditCards,
    cards.TravelCreditCards,
    cards.CreditLimits
  ],
  'student-credit-cards': [
    cards.APR,
    cards.BalanceTransfers,
    cards.CashbackCreditCards,
    cards.CreditCardBasics,
    cards.RewardsCreditCards,
    cards.SecuredCreditCards,
    cards.CreditLimits,
    cards.TravelCreditCards
  ],
  'travel-credit-cards': [
    cards.APR,
    cards.BalanceTransfers,
    cards.CashbackCreditCards,
    cards.CreditCardBasics,
    cards.RewardsCreditCards,
    cards.SecuredCreditCards,
    cards.StudentCreditCards,
    cards.CreditLimits
  ],
  'establishing-credit': [
    cards.ReportAdvice,
    cards.ScoreAdvice,
    cards.ImproveCredit,
    cards.CreditRepair,
    cards.LifeStages,
    cards.PersonalFinance
  ],
  'improve-credit': [cards.ReportAdvice, cards.ScoreAdvice, cards.CreditRepair, cards.Dispute],
  'death-of-a-relative': [
    cards.Divorce,
    cards.Employment,
    cards.Kids,
    cards.Marriage,
    cards.Students,
    cards.EstablishingCredit
  ],
  divorce: [
    cards.DeathRelative,
    cards.Employment,
    cards.Kids,
    cards.Marriage,
    cards.Students,
    cards.EstablishingCredit
  ],
  employment: [
    cards.DeathRelative,
    cards.Divorce,
    cards.Employment,
    cards.Kids,
    cards.Marriage,
    cards.Students,
    cards.EstablishingCredit
  ],
  kids: [
    cards.DeathRelative,
    cards.Divorce,
    cards.Employment,
    cards.Marriage,
    cards.Students,
    cards.EstablishingCredit
  ],
  marriage: [
    cards.DeathRelative,
    cards.Divorce,
    cards.Employment,
    cards.Kids,
    cards.Students,
    cards.EstablishingCredit
  ],
  students: [
    cards.DeathRelative,
    cards.Divorce,
    cards.Employment,
    cards.Kids,
    cards.Marriage,
    cards.EstablishingCredit
  ],
  'report-advice': [
    cards.ScoreAdvice,
    cards.ImproveCredit,
    cards.Cosigning,
    cards.CreditLimits,
    cards.Deniedcredit,
    cards.Inquiry
  ],
  bankruptcy: [
    cards.Dispute,
    cards.ImproveCredit,
    cards.Chargeoff,
    cards.Closedaccounts,
    cards.Collections,
    cards.Foreclosure,
    cards.Latepayment,
    cards.Repossession
  ],
  'charge-off': [
    cards.Dispute,
    cards.ImproveCredit,
    cards.Bankruptcy,
    cards.Closedaccounts,
    cards.Collections,
    cards.Foreclosure,
    cards.Latepayment,
    cards.Repossession
  ],
  'closed-accounts': [
    cards.Dispute,
    cards.ImproveCredit,
    cards.Bankruptcy,
    cards.Chargeoff,
    cards.Collections,
    cards.Foreclosure,
    cards.Latepayment,
    cards.Repossession
  ],
  collections: [
    cards.Dispute,
    cards.ImproveCredit,
    cards.Bankruptcy,
    cards.Chargeoff,
    cards.Closedaccounts,
    cards.Foreclosure,
    cards.Latepayment,
    cards.Repossession
  ],
  cosigning: [
    cards.ReportAdvice,
    cards.ScoreAdvice,
    cards.ImproveCredit,
    cards.CreditLimits,
    cards.Deniedcredit,
    cards.Inquiry
  ],
  'credit-limit': [
    cards.ReportAdvice,
    cards.ScoreAdvice,
    cards.ImproveCredit,
    cards.Cosigning,
    cards.Deniedcredit,
    cards.Inquiry
  ],
  'credit-repair': [
    cards.Dispute,
    cards.FraudIdentityTheft,
    cards.ReportAdvice,
    cards.ScoreAdvice,
    cards.ImproveCredit,
    cards.Negativeinformation
  ],
  'denied-credit': [
    cards.ReportAdvice,
    cards.ScoreAdvice,
    cards.ImproveCredit,
    cards.Cosigning,
    cards.CreditLimits,
    cards.Inquiry
  ],
  dispute: [
    cards.CreditRepair,
    cards.FraudIdentityTheft,
    cards.ReportAdvice,
    cards.ScoreAdvice,
    cards.ImproveCredit,
    cards.Negativeinformation
  ],
  foreclosure: [
    cards.Dispute,
    cards.ImproveCredit,
    cards.Bankruptcy,
    cards.Chargeoff,
    cards.Closedaccounts,
    cards.Collections,
    cards.Latepayment,
    cards.Repossession
  ],
  inquiry: [
    cards.ReportAdvice,
    cards.ScoreAdvice,
    cards.ImproveCredit,
    cards.CreditLimits,
    cards.Cosigning,
    cards.Deniedcredit
  ],
  'late-payment': [
    cards.Dispute,
    cards.ImproveCredit,
    cards.Bankruptcy,
    cards.Chargeoff,
    cards.Closedaccounts,
    cards.Collections,
    cards.Foreclosure,
    cards.Repossession
  ],
  'negative-information': [
    cards.Dispute,
    cards.CreditRepair,
    cards.ImproveCredit,
    cards.Bankruptcy,
    cards.Chargeoff,
    cards.Closedaccounts,
    cards.Collections,
    cards.Foreclosure,
    cards.Latepayment,
    cards.Repossession
  ],
  repossession: [
    cards.Dispute,
    cards.ImproveCredit,
    cards.Bankruptcy,
    cards.Chargeoff,
    cards.Closedaccounts,
    cards.Collections,
    cards.Foreclosure,
    cards.Latepayment
  ],
  'score-advice': [
    cards.ReportAdvice,
    cards.ImproveCredit,
    cards.EstablishingCredit,
    cards.CreditRepair,
    cards.LifeStages,
    cards.FraudIdentityTheft
  ],
  cybersecurity: [
    cards.Databreach,
    cards.Fraudalert,
    cards.Prevention,
    cards.Securityfreeze,
    cards.Dispute,
    cards.ReportAdvice,
    cards.ScoreAdvice,
    cards.ImproveCredit
  ],
  'data-breach': [
    cards.Cybersecurity,
    cards.Fraudalert,
    cards.Prevention,
    cards.Securityfreeze,
    cards.Dispute,
    cards.ReportAdvice,
    cards.ScoreAdvice,
    cards.ImproveCredit
  ],
  'fraud-alert': [
    cards.Cybersecurity,
    cards.Databreach,
    cards.Prevention,
    cards.Securityfreeze,
    cards.Dispute,
    cards.ReportAdvice,
    cards.ScoreAdvice,
    cards.ImproveCredit
  ],
  prevention: [
    cards.Cybersecurity,
    cards.Databreach,
    cards.Fraudalert,
    cards.Securityfreeze,
    cards.Dispute,
    cards.ReportAdvice,
    cards.ScoreAdvice,
    cards.ImproveCredit
  ],
  'security-freeze': [
    cards.Cybersecurity,
    cards.Databreach,
    cards.Fraudalert,
    cards.Prevention,
    cards.Dispute,
    cards.ReportAdvice,
    cards.ScoreAdvice,
    cards.ImproveCredit
  ],
  'auto-insurance': [
    cards.Healthinsurance,
    cards.Homeinsurance,
    cards.LifeInsurance,
    cards.PetInsurance,
    cards.Insurancereviews,
    cards.PersonalFinance
  ],
  'health-insurance': [
    cards.Autoinsurance,
    cards.Homeinsurance,
    cards.LifeInsurance,
    cards.PetInsurance,
    cards.Insurancereviews,
    cards.PersonalFinance
  ],
  'home-insurance': [
    cards.Autoinsurance,
    cards.Healthinsurance,
    cards.LifeInsurance,
    cards.PetInsurance,
    cards.Insurancereviews,
    cards.PersonalFinance
  ],
  'life-insurance': [
    cards.Autoinsurance,
    cards.Healthinsurance,
    cards.Homeinsurance,
    cards.PetInsurance,
    cards.Insurancereviews,
    cards.PersonalFinance
  ],
  'pet-insurance': [
    cards.Autoinsurance,
    cards.Healthinsurance,
    cards.Homeinsurance,
    cards.LifeInsurance,
    cards.Insurancereviews,
    cards.PersonalFinance
  ],
  'insurance-reviews': [
    cards.Autoinsurance,
    cards.Healthinsurance,
    cards.Homeinsurance,
    cards.LifeInsurance,
    cards.PetInsurance,
    cards.PersonalFinance
  ],
  'auto-loans': [
    cards.Loanbasics,
    cards.Personalloans,
    cards.Studentloans,
    cards.Mortgage,
    cards.HELOC,
    cards.Refinance,
    cards.Debt,
    cards.PersonalFinance
  ],
  'loan-basics': [
    cards.Autoloans,
    cards.Personalloans,
    cards.Studentloans,
    cards.Mortgage,
    cards.HELOC,
    cards.Refinance,
    cards.Debt,
    cards.PersonalFinance
  ],
  'personal-loans': [
    cards.Autoloans,
    cards.Loanbasics,
    cards.Studentloans,
    cards.Mortgage,
    cards.HELOC,
    cards.Refinance,
    cards.Debt,
    cards.PersonalFinance
  ],
  'student-loans': [
    cards.Autoloans,
    cards.Loanbasics,
    cards.Personalloans,
    cards.Mortgage,
    cards.HELOC,
    cards.Refinance,
    cards.Debt,
    cards.PersonalFinance
  ],
  'news-trends': [
    cards.Research,
    cards.CreditreportScores,
    cards.FraudIdentityTheft,
    cards.PersonalFinance
  ],
  research: [
    cards.NewsTrends,
    cards.CreditreportScores,
    cards.FraudIdentityTheft,
    cards.PersonalFinance
  ],
  budgeting: [
    cards.PersonalFinance,
    cards.Debt,
    cards.Saving,
    cards.Investing,
    cards.Retirement,
    cards.Taxes
  ],
  debt: [
    cards.PersonalFinance,
    cards.Budgeting,
    cards.Saving,
    cards.Investing,
    cards.Retirement,
    cards.Taxes
  ],
  investing: [
    cards.PersonalFinance,
    cards.Budgeting,
    cards.Debt,
    cards.Saving,
    cards.Retirement,
    cards.Taxes
  ],
  retirement: [
    cards.PersonalFinance,
    cards.Budgeting,
    cards.Debt,
    cards.Saving,
    cards.Investing,
    cards.Taxes
  ],
  saving: [
    cards.PersonalFinance,
    cards.Budgeting,
    cards.Debt,
    cards.Investing,
    cards.Retirement,
    cards.Taxes
  ],
  taxes: [
    cards.PersonalFinance,
    cards.Budgeting,
    cards.Debt,
    cards.Saving,
    cards.Investing,
    cards.Retirement
  ],
  mortgage: [cards.HELOC, cards.Refinance, cards.Rentals, cards.Debt],
  heloc: [cards.Mortgage, cards.Refinance, cards.Rentals, cards.Debt],
  refinance: [cards.Mortgage, cards.HELOC, cards.Rentals, cards.Debt],
  rentals: [cards.Mortgage, cards.HELOC, cards.Refinance, cards.Debt],
  'small-business': [
    cards.CreditreportScores,
    cards.FraudIdentityTheft,
    cards.Banking,
    cards.CreditCards,
    cards.Loans,
    cards.Taxes
  ]
};
export const heroSections: ILinksSection = {
  home: [
    cards.CreditreportScores,
    cards.FraudIdentityTheft,
    cards.Banking,
    cards.CreditCards,
    cards.Loans,
    cards.Insurance,
    cards.Mortgage,
    cards.Investing,
    cards.PersonalFinance,
    cards.NewsResearch
  ],
  banking: [
    cards.CertificateDepositCD,
    cards.CheckingAccount,
    cards.MoneyMarket,
    cards.SavingsAccount
  ],
  'credit-cards': [
    cards.APR,
    cards.BalanceTransfers,
    cards.CashbackCreditCards,
    cards.CreditCardBasics,
    cards.RewardsCreditCards,
    cards.SecuredCreditCards,
    cards.StudentCreditCards,
    cards.TravelCreditCards
  ],
  'credit-advice': [
    cards.ReportAdvice,
    cards.ScoreAdvice,
    cards.EstablishingCredit,
    cards.ImproveCredit,
    cards.CreditRepair,
    cards.LifeStages
  ],
  'life-stages': [
    cards.DeathRelative,
    cards.Divorce,
    cards.Employment,
    cards.Kids,
    cards.Marriage,
    cards.Students,
    cards.EstablishingCredit,
    cards.ImproveCredit
  ],
  'fraud-and-identity-theft': [
    cards.Cybersecurity,
    cards.Databreach,
    cards.Fraudalert,
    cards.Prevention,
    cards.Securityfreeze,
    cards.Dispute,
    cards.ReportAdvice,
    cards.ScoreAdvice
  ],
  insurance: [
    cards.Autoinsurance,
    cards.Healthinsurance,
    cards.Homeinsurance,
    cards.LifeInsurance,
    cards.PetInsurance,
    cards.Insurancereviews
  ],
  loans: [
    cards.Autoloans,
    cards.Loanbasics,
    cards.Personalloans,
    cards.Studentloans,
    cards.Mortgage,
    cards.HELOC,
    cards.Refinance,
    cards.Debt
  ],
  'personal-finance': [
    cards.Budgeting,
    cards.Debt,
    cards.Saving,
    cards.Investing,
    cards.Retirement,
    cards.Taxes
  ]
};
export const calculatorExploreMoreLinks: IFontIconCard[] = [
  {
    link: '/apr-calculator/',
    heading: 'APR Calculator',
    icon: ''
  },
  {
    link: '/personal-loan-calculator/',
    heading: 'Personal Loan Calculator',
    icon: ''
  },
  {
    link: '/credit-card-payoff-calculator/',
    heading: 'Credit Card Payoff Calculator',
    icon: ''
  },
  {
    link: '/mortgage-calculator/',
    heading: 'Mortgage Calculator',
    icon: ''
  },
  {
    link: '/car-payment-calculator/',
    heading: 'Car Payment Calculator',
    icon: ''
  },
  {
    link: '/savings-calculator/',
    heading: 'Savings Calculator',
    icon: ''
  }
];
export const scoreGuideLinks: IFontIconCard[] = [
  cards.ReportAdvice,
  cards.ImproveCredit,
  cards.EstablishingCredit,
  cards.CreditRepair,
  cards.LifeStages,
  cards.FraudIdentityTheft
];
